'use client';
import { getPathFromUrl } from '@/utils/getPathFromUrl';
import Link from 'next/link';
import React, { useState } from 'react';
import { FaAngleRight } from 'react-icons/fa6';

const MobileMenuItem = ({ item, onClose }: { item: any, onClose: () => void }) => {
  const [open, setOpen] = useState(false);
  const hasChildren = item.children && item.children.length > 0;
  const url = getPathFromUrl(item?.url);

  // This handles clicking the actual text/link
  const handleLinkClick = () => {
    // 1. Close the sidebar
    onClose();
    // 2. Reset body overflow (standard practice when closing overlays)
    document.body.style.overflow = '';
  };

  // This handles clicking the arrow icon specifically
  const toggleSubmenu = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(!open);
  };

  return (
    <li className={hasChildren ? 'menu-item-has-children' : ''}>
      <div className="d-flex justify-content-between align-items-center pe-3">
        {item.href || url ? (
          <Link
            href={`${item.href || url || '#'}`}
            onClick={handleLinkClick}
            className="w-100"
          >
            {item?.title || item?.name}
          </Link>
        ) : (
          /* Fallback if no URL exists, still allow toggle via text click */
          <span onClick={toggleSubmenu} style={{ cursor: 'pointer', flex: 1 }}>
            {item?.title || item?.name}
          </span>
        )}
        
        {hasChildren && (
          <div 
            onClick={toggleSubmenu} 
            style={{ cursor: 'pointer', padding: '10px' }}
          >
            <FaAngleRight
              style={{ 
                transition: 'transform 0.3s ease',
                transform: open ? 'rotate(90deg)' : 'rotate(0deg)' 
              }}
            />
          </div>
        )}
      </div>

      {hasChildren && open && (
        <ul className="menu-section" style={{ paddingLeft: '1rem', borderLeft: '1px solid #eee' }}>
          {item.children.map((child: any, index: number) => (
            <MobileMenuItem item={child} key={index} onClose={onClose} />
          ))}
        </ul>
      )}
    </li>
  );
};

export default MobileMenuItem;